import axios from "axios";
import { t } from "i18next";
import _ from "lodash";

import AlertsService from "services/alerts-service";

import { mergeStorage, omitStorage } from "hooks/useStorage";

const RoomsApi = {
    getDormitoryRooms: async (dormitoryId: string) => {
        try {
            const { data: response } = (await axios.get(`/dormitories/${dormitoryId}/rooms`)) as any;
            mergeStorage(`dormitories.${dormitoryId}.rooms`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("4mkwegqsv9o"));
        }
    },
    getAllRooms: async () => {
        try {
            const { data: response } = (await axios.get(`/rooms/all`)) as any;
            mergeStorage(`rooms`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("m7iihueat"));
        }
    },
    createRoom: async (dormitoryId: string, details: any) => {
        try {
            const { data: response } = (await axios.post(`/rooms`, { details, dormitoryId })) as any;
            await RoomsApi.getDormitoryRooms(dormitoryId);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("o92m7img86g"));
        }
    },
    updateRoom: async (room: { id: string; dormitoryId: string; [key: string]: any }) => {
        try {
            const { data: response } = (await axios.put(`/rooms`, room)) as any;
            await RoomsApi.getDormitoryRooms(room.dormitoryId);
            AlertsService.showSuccess(`Помещение успешно обновлено`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("ha3z0jvditu"));
        }
    },
    deleteRoom: async (roomId: string, dormitoryId: string) => {
        try {
            await axios.delete(`/rooms/${roomId}`);
            omitStorage(`dormitories.${dormitoryId}.rooms.${roomId}`);
            AlertsService.showSuccess(`Помещение успешно удалено`);
            return;
        } catch (error) {
            throw AlertsService.showError(t("w2myembv9l"));
        }
    },
};

export default RoomsApi;
